var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  exports = function () {
    var sign = Math.sign;
    if (typeof sign !== "function") return false;
    return sign(10) === 1 && sign(-20) === -1;
  };

  return exports;
}